/**
 * PDSTable js
 */


export const PDSTable = (function () {

    //Global Variables
    var table;
    var editData = '<button class="text-primary btn m-0 p-0 ml-2 mr-3 myds-edit"><i class="fas fa-edit"></i></button>';
    var deleteData = '<button class="text-primary btn m-0 p-0 myds-remove"><i class="far fa-trash-alt"></i></button>';
    var windowWidth = $(window).width();
    var modal;
    var indexToDelete;
    var indexToEdit;
    var inclusionsList;
    var data_dataset;
    var data_id;
    var nestedTableContent;
    var jsonData = "";
    let elementDisplay;

    var init = function () {

        // Finds the table when page has loaded, if it's outside it won't find the table
        table = $('#table');
        // check the viewport size before we initialise the table
        if ((windowWidth <= 510)) {
            table.bootstrapTable({
                cardView: true,
                detailViewByClick: true,
                classes: 'table table-bordered myds-custom-table myds-custom-table--not-fixed'
            });
        } else {
            table.bootstrapTable({
                loadingFontSize: '16px'
            });
        }

        //InclusionsList is the list for the names of the fields
        //displayed when a row is expanded
        inclusionsList = table.data('inclusionsList');
        nestedTableContent = table.data('nestedTable');
        initEvents();
    }
    /**
     * Function that replaces ajax call from bootstrapTable.
     * Passes the data to use, enables server side pagination and search.
     * @param {*} params 
     */
    var ajaxRequest = function (params) {
        //Gets the dataset from the table
        data_dataset = table.find('thead').data('id');
        var url = `/pds-read-data/` + data_dataset;
        var search = encodeURIComponent(params.data.search);
        
        if(params.data.sort){
            url += `?sort=${params.data.sort}&order=${params.data.order}&search=${search}&offset=${params.data.offset}&limit=${params.data.limit}`;
        } else {
            url += `?search=${search}&offset=${params.data.offset}&limit=${params.data.limit}`;
        }
        /**
         * If instance is passed as a parameter (which can happen when refreshing the table) use that instance to filter the endpoint
         * Otherwise, get all the data for all instances
         */
        if(params.data.instance !== undefined){
            url += `&instance=${params.data.instance}`;
        } else {
            url += `&instance=-1`;
        }
            
        $.get(url).then(function (res) {
            params.success(res); 
        });
    }
    /**
     * Function that creates the view inside of the table when the icon (+) is clicked to expand the row.
     * This will only will be called when someone clicks the icon, it adds a 'tr' with a class "detail-view"
     * in that tr is where this view will be displayed.
     * @param {*} index row index - currently on the table(autogenerated by bootstrapTable),  
     * @param {*} data to display - must be an array of objects,
     * @param {*} element_td td element (autogenerated by bootstrapTable)
     */
    var detailFormatter = function (index, data, element_td) {
        var html = [];
        var hscr = false;
        //Checks if an inclusionsList exists and if it doesn't it will create
        //an inclusionsList from the value of the data object keys
        if (inclusionsList === null || typeof inclusionsList === 'undefined') {
            inclusionsList = {};
            for (var key in data) {
                //replaces all _ with spaces and changes all the first letters after a space to upper case
                var fieldName = key.replace(/_/g, ' ').replace(/(?: |\b)(\w)/g, function (keys) {
                    return keys.toUpperCase()
                });
                //removes the first part of the key until the first space (removing e.g 'Cred' and leaving 'Password')
                fieldName = fieldName.split(' ').slice(1).join(' ');
                if (fieldName !== '') {
                    inclusionsList[key] = fieldName;
                }
            }
        }

        $.each(inclusionsList, function (field, displayName) {
            var value = data[field];

            if (field.indexOf('date') > -1 || field.indexOf('created') > -1 || field.indexOf('modified') > -1 || field.indexOf('time') > -1) {
                var date = convertDate(value);
                var time = convertTime(value);
                value = date + ' ' + time;
            }

            var rowValue = '<p class="text-primary font-weight-bold">' + value + '</p>';

            if (field.indexOf('url') > -1) {
                var link = convertLink(value);
                rowValue = '<a class="font-weight-bold myds-url-js" href="' + link + '">' + value + '</a>';
            }

            if (field.indexOf('notes') > -1) {
                rowValue = `<pre class="text-primary">${value}</pre>`;
            }

            if (field.indexOf('referree_availability') > -1) {
                jsonData = data.referree_availability;
                rowValue = `<div class="text-primary json-data"></div>`
            }

            html.push('<div class="row"><div class="col-4 col-md-2"> <p class="text-primary" data-field="' + field + '">' + displayName +
                ': </p></div><div class="col col-md-6">' + rowValue + '</div></div>');

            if (field.indexOf('passphrase') > -1) {
                html.push('<div class="row"><div class="col-4 col-md-2"> <p class="text-primary" data-field="' + field + '">' + displayName +
                    ' View: </p></div><div class="col col-md-6 mb-3"><table id="tablePassphrase' + index + '" data-passphrase="' + value + '" data-check-on-init="true" data-classes="table text-primary" role="presentation"></table></div></div>');
            }

            if (field.indexOf('hscr_data') > -1) {
                hscr = true;
                jsonData = data.hscr_data;
                element_td[0].innerHTML = "";
                createJsonView(element_td, jsonData);
            }           
            
        });

        
        if (!hscr) {
            element_td.append(html.join(''));
            // check if variable is not empty - means a field will contain json data and must be change to display using JSON viewer
            if (jsonData != "") {
                // make sure to add to the field the class 'json-data' to display in there the json data
                elementDisplay = $('.json-data');
                createJsonView(elementDisplay, jsonData);
            }

            if (nestedTableContent) {
                //add the table to the expanded view
                element_td.append('<table id="nestedTable-' + data.id + '"></table>');
                buildNestedTable(data.id);
                element_td.append('<br>');
            }

            createPassphraseView(index);
        } else {
            // if it's the hscr record we simply want to show the json on the page and ignore any other changes
            return '';
        }
        
    }
    /**
     * creates the view of json data in a "pretty" format rather than display the raw data
     * @param {element} element the html element where the data must be displayed
     * @param {json} dataJson json data to be displayed
     */
    var createJsonView = function (element, dataJson) {
        return new JsonViewer({
            container: element[0], 
            data: dataJson, 
            theme: 'light', 
            expand: false
        });
    }
    /**
     * Function that builds a nested table inside the detailFormatter
     * Makes an ajax request to get the data for this table 
     * @param {*} id the id of the parent data that maps to the foreign key of the nestedTable data
     */
    var buildNestedTable = function (id) {
        // url for making call to back end to retrieve the data we need filtering on the id (foreign key)
        var url = '/pds-read-filtered-data/' + nestedTableContent.dataset 
        + '?' + 'field=' + nestedTableContent.foreign_key + '&operator==' + '&value=' + id;

        //ajax requests gets table data in response and uses this data to build the table
        $.get(url).then(function (response) {
            var columns = [];
            var data = [];

            //adds headers to columns
            $.each(nestedTableContent.headers, function(index, element) {
                columns.push ({
                    field: element.field,
                    title: element.title
                })
                //adds row data
                for (const nestedDatasetData of response) {
                    data.push(nestedDatasetData);
                }
            })

            var $nestedTable = $('#nestedTable-' + id);
            $nestedTable.bootstrapTable({
                columns: columns,
                data: data,
                detailView: true,
                onExpandRow: function (i, row, $detail) {
                    let expandedView = '';
                    $.each(nestedTableContent.inclusions_list, function(index, element) {
                        expandedView += '<p class="mb-0"><span class="text-primary">' + element + ': </span>' + row[index] + '</p>';
                    })
                    $detail.html(expandedView);
                }
            });
            $("#nestedTable-" + id + " thead").addClass("text-primary");
            
        });
    }

    /**
     * Function that formats display of a particular column, 
     * for this function to run its name must be included in
     * the data-formatter value of the column header 
     * BootstapTable calls this function when the detail-icon is clicked (+)
     * (this) is the column object
     * @param {*} value the field value, 
     * @param {*} row the row record data,
     * @param {*} index the row index
     * @returns string
     */
    var operateFormatter = function (value, row, index) {
        return [
            editData, deleteData
        ].join('');
    }

    /**
     * Function that formats the display of a url column
     * formatter field must be defined in the html and be equal to the name of this function
     * @param {*} value the field value, 
     * @param {*} row the row record data,
     * @param {*} index the row index
     * @returns string
     */
    var linkFormatter = function (value, row, index) {
        var link = convertLink(value);
        return '<a href="' + link + '" class="myds-url-js">' + value + '</a>';
    }

    var createPassphraseView = function (index) {
        var passphraseTable = $('#tablePassphrase' + index);
        //Gets the value of the passphrase from the data-passphrase attribute
        var passphrase = passphraseTable.data('passphrase');

        if (typeof passphrase !== 'undefined') {
            passphrase = passphrase.split('');
            buildTable(passphraseTable, passphrase, 1);
        }

    }

    /**
     * Formatter function that takes two parameters
     * sets the style for the rows and supports css classes
     * @param {*} row row record data
     * @param {*} index row index
     * @returns css or classes/styles
     */
    var rowStyle = function (row, index) {
        
        var classes = {
                'overflow': 'hidden',
                'text-overflow': 'ellipsis',
                'white-space': 'nowrap'
        }
        if (windowWidth > 500) {
            if (index % 2 === 0){
                classes['background-color'] = '#EEEAF6';
                return {
                    css: classes
                }
            }
        }

        return {
            css: classes
          }
        
    }

    /**
     * Function that fills the passphrase table with the data passed
     * @param {*} tablePassphrase table element, 
     * @param {*} cells array - data to fill table, 
     * @param {*} rows int - how many rows will be created
     */
    var buildTable = function (tablePassphrase, cells, rows) {
        var j = 1;
        var row = {};
        var columns = [];
        var data = [];

        for (var i = 0; i < cells.length; i++) {
            columns.push({
                //Adds data-field value to each column
                field: 'pass-' + i,
                //Value to be displayed on each column
                title: j,
                //Adds style - needed for responsive view as the default 
                //card-view(used in mobile view) in bootstrap table won't add table-border
                cellStyle: function () {
                    return {
                        css: {
                            'font-weight': 'bold',
                            'padding-left': '10px',
                            border: '1px solid #b9a7cb'
                        }
                    }
                }
            });
            j++;
        }

        for (let k = 0; k < cells.length; k++) {
            row['pass-' + k] = cells[k];
        }

        data.push(row);

        //Checks size of window width and builds table
        //card-view true for mobile false for laptop-desktop
        if ((windowWidth <= 500)) {
            tablePassphrase.bootstrapTable({
                columns: columns,
                data: data,
                cardView: true,
                detailViewByClick: true
            });
            $('#tablePassphrase tr[data-index="0"]').children('td[colspan]').css('border', 'hidden');
        } else {
            tablePassphrase.bootstrapTable({
                columns: columns,
                data: data,
                cardView: false,
                detailViewByClick: false,
                theadClasses: 'thead-light'
            });
            $('#tablePassphrase th[data-field]').addClass('text-primary');
        }
        tablePassphrase.removeClass('table-hover');
    }
    
    var convertLink = function(link) {
        if(link.indexOf("http") === -1 || link.indexOf("https") === -1 ) {
            return 'https://' + link;
        } 
        return link;
    }
    /**
     * BootstrapTable event functions attached here to the edit and delete buttons
     * on each click a modal is displayed
     * global variable modal changes in value
     * @param {*} e the jQuery event, 
     * @param {*} value the field value,
     * @param {*} row row record data, where the button is, 
     * @param {*} index row index (bootstrapTable adds this index)
     */
    var operateEvents = {
        'click .myds-edit': function (e, value, row, index) {
            modal = 'edit';
            //updates global variable to the id of the PDS record
            data_id = row.id;
            //updates global variable to the index of the row that was clicked
            indexToEdit = index;
            $('#editModal').modal();
            for (const key in row) {
                var field = $('#editModal').find('input[name="' + key + '"]');
                var textarea = $('#editModal').find('textarea[name="' + key + '"]');
                if (field.length) {
                    field.val(row[key]);
                } else if (textarea.length) {
                    textarea.val(row[key]);
                }
            }
        },
        'click .myds-remove': function (e, value, row, index) {
            $('#deleteModal').modal();
            //updates global variable to the id of the PDS record
            data_id = row.id;
            //updates global variable to the index of the row that was clicked
            indexToDelete = index;
        }
    }

    var initEvents = function () {

        $('.myds-add').on('click', function () {
            $('.modal-body input').val('');
            $('#editModal').modal();
            modal = 'add';
        });

        $('.save').on('click', function (e) {
            e.stopPropagation();
            //Gets the data from the modal form
            var newData = $('form.js-pdstable-edit').serializeArray();

            if (modal == 'add') {
                addRow(newData, data_dataset);
            } else if (modal == 'edit') {
                //passes updated global variable indexToEdit as index
                editRow(indexToEdit, newData, data_id, data_dataset);
            }

        });

        $('.delete').on('click', function () {
            //passes updated global variable indexToDelete as index
            deleteRow(indexToDelete, data_dataset, data_id);
        });
        /**
         * Add click listener to the instances buttons above the table
         * so that when clicked, we refresh the XHR to the backend for
         * data but pass the instance.
         */
        $('.myds-pds-table-instance-button').on('click', function () {

          // If the btn-secondary is on the element, then it is selected.  
          // If so, refresh (which will return all records across instances), reset button UI and stop execution.
          if($(this).hasClass('btn-secondary')) {

            table.bootstrapTable('refresh');
            $('.myds-pds-table-instance-button').removeClass('btn-secondary');
            
          } else {

            var instance = parseInt(this.getAttribute('data-instance'));
            table.bootstrapTable('refresh', {
              query: { instance: instance }
            })
            // Indicate that the button has been clicked
            $('.myds-pds-table-instance-button').removeClass('btn-secondary');
            $(this).toggleClass('btn-secondary');
          }
        });

        table.on('click', '.myds-url-js', function(e){
            e.preventDefault();
            var url = $(this).attr('href');
            Util.openInNewTab(url);
        });
        
    }

    /**
     * Function that turns the values from the form into an array of objects
     * to update the table 
     * @param {*} formArray objects - each field from form
     * @param {*} editFlag boolean 
     * @returns array of objects
     */
    var objectifyData = function (formArray, editFlag) {
        var newData = {};
        var timeStamp = Math.floor(new Date().getTime() / 1000.0);

        for (const field of formArray) {
            let fieldName = field.name;

            if (!editFlag) {
                if (fieldName.indexOf('date') > -1 || fieldName.indexOf('created') > -1 || fieldName.indexOf('modified') > -1 ) {
                    newData[fieldName] = timeStamp;
                    continue;
                }
            } else {
                if (fieldName.indexOf('modified') > -1) {
                    newData[fieldName] = timeStamp;
                    continue;
                }
            }
            newData[fieldName] = field.value;
        }

        return newData;
    }

    /**
     * Function that sends a reques to add a new record on the PDS
     * on success it adds the new values into a new row at the start of the table
     * and it will close the modal view
     * @param {*} newData data in object format to add
     * @param {*} dataset from global variable data_dataset
     */
    var addRow = function (newData, dataset) {
        var formData = objectifyData(newData);
        var csrf = Util.getCSRF();
        
        var promise = PDS.pds.post(dataset, JSON.stringify(formData));
        promise.then(function (response) {
            //adds the id from the new added record
            formData.id = response.last_insert_id;
            table.bootstrapTable('insertRow', {
                index: 0,
                row: formData
            });
            $('#editModal').modal('hide');
            table.bootstrapTable('refresh');
        });
        promise.fail(function (error) {
            Util.toggleAlert('#myds-alert-modal', error.responseJSON.message, 'alert-primary', 5000);
        });
    }

    /**
     * Function that sends a reques to update data record from PDS
     * on success it updates row values on table view and it will close the modal view
     * @param {*} index from global variable indexToEdit
     * @param {*} updatedRow serialized data to update current record
     * @param {*} dataset from global variable data_dataset
     * @param {*} id from global variable data_id
     */
    var editRow = function (index, updatedRow, id, dataset) {
        var formData = objectifyData(updatedRow, true);
        var csrf = Util.getCSRF();

        $.ajax({
            type: 'POST',
            dataType: 'json',
            headers: {
                'isAPI': true,
                'x-csrf-token': csrf
            },
            url: '/pds-update',
            data: {
                datasetID: id,
                data: JSON.stringify(formData),
                dataset: dataset
            }
        }).done(function (response) {
            table.bootstrapTable('updateRow', {
                index: index,
                row: response.transaction
            });
            $('#editModal').modal('hide');
        }).fail(function (error) {
            Util.toggleAlert('#myds-alert-modal', error.responseJSON.message, 'alert');
        });
    }

    /**
     * Function that sends a reques to delete data record from PDS
     * on success it deletes row from view
     * @param {*} index from global variable indexToDelete
     * @param {*} dataset from global variable data_dataset
     * @param {*} id from global variable data_id
     */
    var deleteRow = function (index, dataset, id) {

        var csrf = Util.getCSRF();

        $.ajax({
            type: 'DELETE',
            dataType: 'json',
            headers: {
                'isAPI': true,
                'x-csrf-token': csrf
            },
            url: '/pds-delete',
            data: {
                id: id,
                dataset: dataset
            }
        }).done(function (response) {
            table.bootstrapTable('remove', {
                field: '$index',
                values: [index]
            });
            $('#deleteModal').modal('hide');
        });

    }

    var convertDate = function (timeStamp) {
        var today = new Date(timeStamp * 1000);
        var date = ('0' + today.getDate()).slice(-2) + '/' + ('0' + (today.getMonth() + 1)).slice(-2) + '/' + today.getFullYear();
        return date;
    }

    var convertTime = function (timeStamp) {
        var today = new Date(timeStamp * 1000);
        var hours = today.getHours();
        var mins = "0" + today.getMinutes();
        var time = hours + ":" + mins.substr(-2);
        return time;
    }
     /**
     * joins date and time together whilst also converting unix-timestamp to human-readable format.
     * 
     * @param {*} timestamp timestamp to be converted
     * 
     * @return human-readable format of timestamp as DD/MM/YYYY hours:minutes
     */
    var convertDateAndTime = function (timeStamp) {
        return convertDate(timeStamp) + " " + convertTime(timeStamp);
    }

    /**
     * appends additional data to current column data
     * 
     * @param {*} value the current value to be added to
     * @param {*} row the row that the value to append to the value belongs to
     * 
     * @return the value passed to it plus the concatField of the row
     */
    var concatFormatter = function(value, row) {
        return value + " " + row[this.concatField];
    }

    return {
        init: init,
        ajaxRequest: ajaxRequest,
        detailFormatter: detailFormatter,
        operateFormatter: operateFormatter,
        linkFormatter: linkFormatter,
        rowStyle: rowStyle,
        convertDate: convertDate,
        convertDateAndTime: convertDateAndTime,
        concatFormatter: concatFormatter,
        operateEvents: operateEvents
    }

}());